export class RedirectError extends Error {
}
